import {
  initialState,
  Actions,
  State,
  DELETE_USER_MEDIA,
  DELETE_USER_MEDIA_SUCCESS,
  DELETE_USER_MEDIA_ERROR,
  RESET_DELETE_USER_MEDIA,
} from '../../types/user/delete-media'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case DELETE_USER_MEDIA:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case DELETE_USER_MEDIA_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case DELETE_USER_MEDIA_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      }
    case RESET_DELETE_USER_MEDIA:
      return initialState
    default:
      return state
  }
}

export default reducers
